/* istanbul ignore file */
/**
 * Thrown if an error occurs in the store
 */
export class StoreError extends Error {
  constructor(message: string) {
    super(`[StoreError] ${message}`);
  }
}
